import {Tooltip} from "@mui/material";
import {ElevationReviewItem, ReviewOpeningRef} from "../../../../api/ElevationTool";

// the outside sizes of the openings linking a drw screen elevation: one per size variant, with each
// opening's size in the tooltip.
export function DrwOutsideSizeCol() {
    return {
        name: "Outside Size",
        width: 160,
        render: (data: ElevationReviewItem) => {
            const sizes = Array.from(new Set(data.openings.map(outsideSize).filter(v => v !== "")));
            if(sizes.length === 0) return "";

            return (
                <Tooltip title={data.openings.map(o => `${o.name}: ${outsideSize(o) || "not rendered"}`).join(", ")}>
                    <span>{sizes.join(", ")}</span>
                </Tooltip>
            );
        },
    };
}

function outsideSize(o: ReviewOpeningRef) {
    if(!o.renderingMeta) return "";
    return `${o.renderingMeta.outsideWidth} × ${o.renderingMeta.outsideHeight}`;
}
